/**
 * 不安全区域的占位符
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as utilObject from '../../util-lib/object';
import './styles.scss';

const SAFE_AREA_INSET = getSafeAreaInset();


/**
 * 不安全区域数值变量
 * ```js
 * SAFE_AREA_INSET = {
 *   top: 0,
 *   left: 0,
 *   bottom: 0,
 *   right: 0
 * }
 * ```
 */
export { SAFE_AREA_INSET };


UnSafeArea.propTypes = {
  direction: PropTypes.oneOf(['top', 'bottom']).isRequired,
  className: PropTypes.string,
  style: PropTypes.shape({})
};


/**
 * 不安全区域
 * @param {object} props React props
 * 用例：
 * ```js
 * function Comp() {
 *   return (
 *     <div>
 *       <UnSafeArea direction="top" />
 *       <div>内容</div>
 *       <UnSafeArea direction="bottom" />
 *     </div>
 *   );
 * }
 * ```
 */
export default function UnSafeArea({
  direction, className, style, ...rest
}) {
  const cls = classNames(className, `component-unsafe-area-${direction}`);

  style = style || {};

  // 兼容 Android APP。自家APP暴露的接口
  if (direction === 'top' && isAndroid()) {
    style = {
      ...style,
      height: SAFE_AREA_INSET.top
    };
  }

  return (<div {...rest} className={cls} />);
}

function isAndroid() {
  const ua = utilObject.get(window, 'navigator.userAgent', '');
  return (/android/ig).test(ua);
}

function getSafeAreaInset() {
  if (isAndroid()) {
    return {
      top: utilObject.get(window, 'zzcApp.deviceSafeAreaInsetTop', 0),
      bottom: 0,
      left: 0,
      right: 0
    };
  }

  // iOS
  if (!getSafeAreaInset.node) {
    getSafeAreaInset.node = document.createElement('div');
    getSafeAreaInset.node.className = 'component-unsafe-area';
    document.body.appendChild(getSafeAreaInset.node);
  }

  const rect = getSafeAreaInset.node.getBoundingClientRect();

  return {
    top: rect.top,
    bottom: rect.height,
    left: (rect.left + 1000),
    right: rect.width
  };
}
